declare global {
  interface Window {
    dataLayer: any[];
  }
}

// Initialize the dataLayer if it doesn't exist
window.dataLayer = window.dataLayer || [];

// Define the gtag function
function gtag(...args: any[]) {
  window.dataLayer.push(args);
}

// Initialize Google Analytics
gtag('js', new Date());
gtag('config', 'G-H0S01B99FR');

// Load the Google Analytics script asynchronously
const script = document.createElement('script');
script.async = true;
script.src = 'https://www.googletagmanager.com/gtag/js?id=G-H0S01B99FR';
document.head.appendChild(script);
